<template>
  <div
    :id="item.id"
    :data-id="`shortlist-${item.id}`"
    class="marker draggable"
    @mousedown="startDrag($event)"
    @mouseup="stopDrag($event)"
    @mouseout="stopDrag($event)"
    @mousemove="doDrag($event)"
  >
    {{ item.code }}
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "UserMappingMarker",
  props: {
    locked: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    boundingWidth: {
      type: Number,
      default: 800,
    },
    boundingHeight: {
      type: Number,
      default: 800,
    },
  },
  data() {
    return {
      x: 0,
      y: 0,
      diffX: 0,
      diffY: 0,
      centerX: 0,
      centerY: 0,
      dragging: false,
      normaliseX: 0.5,
      normaliseY: 0.5,
    };
  },
  methods: {
    startDrag(el) {
      if (!this.locked) {
        this.dragging = true;
        const marker = document.getElementById(this.item.id);
        this.diffX = marker.offsetLeft - el.clientX;
        this.diffY = marker.offsetTop - el.clientY;
        console.log("start drag");
      }
    },
    stopDrag() {
      if (!this.locked) {
        this.dragging = false;
        this.normalisePos();
        this.$emit("updatePos", this.item);
        this.$emit("showNoteButton", this.item);
      }
    },
    doDrag(el) {
      if (!this.locked) {
        if (this.dragging == true) {
          let top = el.clientY + this.diffY;
          let left = el.clientX + this.diffX;
          this.item.x = left;
          this.item.y = top;
        }
      }
    },
    normalisePos() {
      const marker = document.getElementById(this.item.id);
      const bounding = marker.getBoundingClientRect();
      let x = this.item.x + bounding.width / 2;
      let y = this.item.y + bounding.height / 2;
      this.centerX = x;
      this.centerY = y;
      this.normaliseX = x / this.boundingWidth;
      this.normaliseY = y / this.boundingHeight;
      this.item.normaliseX = this.normaliseX;
      this.item.normaliseY = this.normaliseY;
    },
  },
};
</script>
